import { createContext, useContext, ReactNode } from 'react';
import { AmendmentUseCases } from '@/features/amendment/application/useCases/amendMentUsecases';
import { useHttpClientCore } from '@/shared';
import { ApiAmendmentRepo } from '../repositories/ApiAmendmentRepo';

interface AmendmentDIContextType {
  amendmentUseCases: AmendmentUseCases;
}

const AmendmentDIContext = createContext<AmendmentDIContextType | undefined>(undefined);

export const AmendmentDIProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientCore();
  const repository = new ApiAmendmentRepo(httpClient);
  const amendmentUseCases = new AmendmentUseCases(repository);

  return (
    <AmendmentDIContext.Provider value={{ amendmentUseCases }}>
      {children}
    </AmendmentDIContext.Provider>
  );
};

export const useAmendmentDI = (): AmendmentDIContextType => {
  const context = useContext(AmendmentDIContext);
  if (!context) {
    throw new Error('useAmendmentDI must be used within AmendmentDIProvider');
  }
  return context;
};
